import React from "react";
import { motion } from "framer-motion";
import rectangularImg from "../../../images/Rectangle.png";
import { getPortalUrl } from "../../../config/domains";

const SectionSix = () => {
  return (
    <motion.div
      className="relative h-[300px] md:h-[400px] flex items-center justify-center text-center my-24"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${rectangularImg}')` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 px-6 md:px-12">
        <motion.h1
          className="text-white text-2xl md:text-4xl font-bold leading-snug"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
        >
          Get Rid Of Language Barriers And Share Your <br />
          Platform Globally With NKENNEAi
        </motion.h1>
        <motion.p
          className="text-gray-200 mt-3 text-sm md:text-base"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          viewport={{ once: true }}
        >
          Unlock seamless communication and expand your reach globally with our
          AI-driven tools.
        </motion.p>

        <a href={getPortalUrl("/signup")} target="_blank" rel="noopener noreferrer">
          <motion.button
            className="mt-5 px-6 py-3 bg-secondary text-white rounded-lg hover:bg-green-700 transition"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.7 }}
            viewport={{ once: true }}
          >
            Try NKENNEAi
          </motion.button>
        </a>
      </div>
    </motion.div>
  );
};

export default SectionSix;
